@let c = composer();
@if (c.undelivered().length > 0) {
  <div
    class="flex items-start gap-3 rounded-xl border border-error/30 bg-error-container/50 px-4 py-3"
    role="alert"
  >
    <mat-icon class="mt-0.5 shrink-0 text-error! text-[20px]! w-5! h-5!">warning</mat-icon>
    <p class="text-sm leading-relaxed text-on-error-container">
      Zprávu se nepodařilo doručit:
      <span class="font-medium">{{ undeliveredNames() }}</span
      >. Ostatním přišla. Příjemci jsou teď nastaveni jen na ně — odešlete zprávu znovu.
    </p>
  </div>
}
<div class="flex flex-col">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
    <mat-label>Příjemci</mat-label>
    <mat-select
      [placeholder]="c.membersLoading() ? 'Načítám uživatele…' : 'Vyberte příjemce'"
      [formField]="c.form.recipientIds"
      multiple
    >
      @for (member of c.recipients(); track member.id) {
        <mat-option [value]="member.id">
          {{ member.firstName }} {{ member.lastName }}
          <span class="text-on-surface-variant">({{ member.email }})</span>
        </mat-option>
      }
    </mat-select>
    @if (c.form.recipientIds().touched() && c.form.recipientIds().invalid()) {
      <mat-error>{{ c.form.recipientIds().errors()[0].message }}</mat-error>
    }
  </mat-form-field>
  <button
    matButton
    type="button"
    class="self-end"
    [disabled]="c.recipients().length === 0"
    (click)="c.toggleAll()"
  >
    <mat-icon>{{ c.allSelected() ? 'remove_done' : 'done_all' }}</mat-icon>
    {{ c.allSelected() ? 'Zrušit výběr' : 'Vybrat všechny' }}
  </button>
</div>

<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
  <mat-label>Předmět</mat-label>
  <input matInput [formField]="c.form.subject" />
  @if (c.form.subject().touched() && c.form.subject().invalid()) {
    <mat-error>{{ c.form.subject().errors()[0].message }}</mat-error>
  }
</mat-form-field>

<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
  <mat-label>Zpráva</mat-label>
  <textarea
    matInput
    cdkTextareaAutosize
    [cdkAutosizeMinRows]="bodyMinRows()"
    cdkAutosizeMaxRows="18"
    [formField]="c.form.body"
  ></textarea>
  <mat-hint align="end">{{ c.form.body().value().length }} / {{ bodyMax }}</mat-hint>
  @if (c.form.body().touched() && c.form.body().invalid()) {
    <mat-error>{{ c.form.body().errors()[0].message }}</mat-error>
  }
</mat-form-field>

<div
  class="flex items-start gap-3 rounded-xl border border-primary/20 bg-primary-container/40 px-4 py-3"
>
  <mat-icon class="mt-0.5 shrink-0 text-primary! text-[20px]! w-5! h-5!">info</mat-icon>
  <p class="text-sm leading-relaxed text-on-surface-variant">
    Zpráva přijde e-mailem. Příjemci uvidí vaše jméno a e-mail, ne však ostatní příjemce. Odpověď
    přijde přímo na váš e-mail, kopii zprávy dostanete také.
  </p>
</div>
